import { render, staticRenderFns } from "./X.vue?vue&type=template&id=72f16d60"
import script from "./X.vue?vue&type=script&lang=js"
export * from "./X.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports